export default __webpack_public_path__ + "static/GRID2022 Stock Disasters RGBlight - Simplify-01-fr-c059d35322aa351a74ce9f00d4c430f9.svg";